export const sumByKey = (array, key, valueKey) => {
	const sums = {};

	for (const item of array) {
		if (!sums[item[key]]) {
			sums[item[key]] = 0;
		}

		sums[item[key]] += item[valueKey];
	}

	return sums;
};

export const groupByKey = (data, key) => data.reduce((result, item) => {
	const groupKey = item[key];
	if (!result[groupKey]) {
		result[groupKey] = [];
	}

	result[groupKey].push(item);
	return result;
}, {});

export const generateYearsArray = (startYear, endYear) => Array.from(
	{ length: endYear - startYear + 1 },
	(_, index) => startYear + index,
);

export const isValidArray = (arr) => Array.isArray(arr) && arr.length > 0;